import React from 'react';
import { CSSObject } from '@core-ui/react-stitch';
import FacetItem from '../FacetItem/FacetItem';
import isOptionApplied from './collaborators/is-option-applied';
import { SimpleFacetProps } from './types';

const getLayoutStyles = (facetLayout: string): CSSObject => {
  switch (facetLayout) {
    case 'list':
      return {
        label: {
          span: {
            width: '100%'
          }
        }
      };
    case 'grid':
      return {
        display: 'flex',
        flexWrap: 'wrap'
      };
    default:
      return {};
  }
};

const SimpleFacet = (props: SimpleFacetProps) => {
  const {
    appliedFacets,
    facetDisplay,
    facetLayout,
    facetName,
    options,
    isBRRedesignEnabled,
    isSwitchContractEnabled,
    isMobile
  } = props;

  const facetOptionsStyle = (): CSSObject => ({
    listStyleType: 'none',
    padding: '0',
    label: {
      position: 'relative'
    },
    span: {
      display: 'block',
      boxSizing: 'border-box'
    },
    'input[type="checkbox"], input[type="radio"]': {
      boxSizing: 'border-box',
      opacity: '0',
      position: 'absolute',
      padding: '0'
    },
    ...getLayoutStyles(facetLayout),
    ...(isBRRedesignEnabled && {
      'div:last-of-type label': {
        marginBottom: '0'
      }
    })
  });

  const simpleFacetStyle = (): CSSObject => ({
    padding: '0.5rem 0'
  });

  const mobileSimpleFacetStyle = (): CSSObject => ({
    padding: '0.5rem 1rem'
  });

  const brSimpleFacetStyle = (): CSSObject => ({
    padding: '0'
  });

  const fluidSimpleFacetStyle = () => {
    if (isBRRedesignEnabled) return brSimpleFacetStyle();
    if (isMobile) return mobileSimpleFacetStyle();
    return simpleFacetStyle();
  };

  const getAppliedValue = (option: any) =>
    isOptionApplied(option, appliedFacets, facetName);

  return (
    <div css={fluidSimpleFacetStyle}>
      <div css={facetOptionsStyle}>
        {options
          .filter(option => option.isActive === 'true')
          .map(option => (
            <FacetItem
              key={option.id}
              applied={getAppliedValue(option)}
              facetDisplay={facetDisplay}
              facetName={facetName}
              isBRRedesignEnabled={isBRRedesignEnabled}
              isMobile={isMobile}
              option={option}
            />
          ))}
      </div>
    </div>
  );
};

export default SimpleFacet;
